export default "__VITE_ASSET__CsXVo0tU__"